import { css } from '@emotion/css';
import { DurationTimer } from '../../shared/components/DurationTimer';
import { Colors } from '../../shared/styles/colors';
import { labelStyle, tabularNumbersStyle } from '../../shared/styles/text';
import { Radius, Shadow } from '../../shared/styles/tokens';

interface ISessionTotalOverviewProps {
  sessionStartTimeStamp: Date;
  sessionTotalCost: string;
  currency: string;
  groupId: number;
}

export const SessionTotalOverview = (
  props: ISessionTotalOverviewProps,
): JSX.Element => {
  const { sessionStartTimeStamp, sessionTotalCost, currency = 'eur' } = props;

  return (
    <div className={sessionTotalOverviewStyle}>
      <div className={sessionTotalOverviewInfoStyle}>
        <DurationTimer startTime={sessionStartTimeStamp} />
        <div>
          <label>Total</label>
          <div className={sessionTotalOverviewCostStyle}>
            <span className={sessionTotalOverviewAmountStyle}>
              {sessionTotalCost}
              {' '}
            </span>
            <span className={sessionTotalOverviewCurrencyStyle}>
              {currency}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

const sessionTotalOverviewStyle = css`
  background-color: rgba(255, 255, 255, 0.94);
  -webkit-backdrop-filter: saturate(160%) blur(14px);
  backdrop-filter: saturate(160%) blur(14px);
  border-top: 1px solid ${Colors.BORDER};
  border-top-left-radius: ${Radius.xl};
  border-top-right-radius: ${Radius.xl};
  box-shadow: ${Shadow.nav};
  padding: 1.25rem 1.5rem calc(1.5rem + env(safe-area-inset-bottom, 0px)) 1.5rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: fixed;
  bottom: 0px;
  left: 0px;
  z-index: 100;
`;

const sessionTotalOverviewInfoStyle = css`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 1rem;
  width: 100%;
  max-width: 24rem;
  margin: 0 auto;

  label {
    ${labelStyle.toString()}
    color: ${Colors.TEXT_SECONDARY};
    text-transform: capitalize;
  }

  > div {
    display: flex;
    flex-direction: column;
    > label {
      margin-bottom: 0.5rem;
    }
  }
`;

const sessionTotalOverviewCostStyle = css`
  ${tabularNumbersStyle}
  display: inline-flex;
  align-items: baseline;
  border: 2px solid ${Colors.INK};
  border-radius: ${Radius.md};
  padding: 0.125rem 0.75rem;
  color: ${Colors.INK};
`;

const sessionTotalOverviewAmountStyle = css`
  font-size: 2rem;
  line-height: 120%;
`;

const sessionTotalOverviewCurrencyStyle = css`
  font-size: 0.75rem;
  line-height: 0.9rem;
  letter-spacing: 0.04em;

  text-transform: uppercase;
`;
